<template>
  <VPopup
    :target="target"
    visible
    show-pointer
    position="bottom"
    :css-classes="['change-demand-v2-option-qty-popup']"
    @close="$core.dialogs.ChangeDemandV2OptionQtyPopup.hide()"
  >
    <VInputNumberRusV2
      ref="qtyInput"
      v-model="qtySelected"
      :type="Qty"
      :unit="row?.unit"
      @keydown.enter="saveQty"
    />

    <footer>
      <VButton
        theme="primary"
        @click="saveQty"
      >
        Сохранить
      </VButton>
      <VButton @click="closePopup">
        Отмена
      </VButton>
    </footer>
  </VPopup>
</template>

<style lang="scss">
.change-demand-v2-option-qty-popup {
  padding: 10px;

  footer {
    display:         flex;
    justify-content: space-between;
    margin-top:      10px;
  }
}
</style>

<script lang="ts">

import DemandsV2Service from '@/domains/DemandsV2/DemandsV2Service';
import DemandOption     from '@/domains/DemandsV2/DemandOption';
import Qty              from '@/core/types/Qty';

export default defineComponent({
  name: 'ChangeDemandV2OptionQtyPopup',

  props: {
    target: {
      type:    [HTMLElement, Object] as PropType<HTMLElement | null>,
      default: null,
    },
    row: {
      type:    DemandOption,
      default: null,
    },
  },

  emits: [
    DemandOption.Events.Updated,
    'close',
  ],

  setup() {
    return {
      Qty,
    };
  },

  data() {
    let qtySelected;
    /** Нулевое количество — валидное значение, поэтому Qty.zero(),
     *  а не подстановка нуля через ||: у Qty любое значение истинно. */
    if (this.row!.qtySelected === null || this.row!.qtySelected === undefined) {
      qtySelected = Qty.zero();
    }
    else {
      qtySelected = this.row!.qtySelected;
    }

    this.$nextTick(() => {
      (this.$refs.qtyInput as any)?.focus?.();
    });

    return {
      /** Qty, а не число: значение уходит в option.qtySelected, а тот
       *  типизирован Qty и сразу идёт в арифметику (calculateSums,
       *  распределение по заявкам). Голое число там ломает всё. */
      qtySelected,
    };
  },

  methods: {
    async saveQty(): Promise<void> {
      if (this.row === null) {
        // Строки нет — сохранять нечего
      }
      else {
        this.row!.qtySelected = this.qtySelected as Qty;

        const isSuccess = await DemandsV2Service.updateOption(this.row!);

        if (isSuccess) {
          this.$emit(DemandOption.Events.Updated);
        }

        this.closePopup();
      }
    },

    closePopup(): void {
      this.$emit('close');
    },
  },
});
</script>
